export default __webpack_public_path__ + "static/task6-300528eff3479037d3e9e3ab876e2fd3.webp";